module.exports = __webpack_public_path__ + "112c7e87b92f15dda2331dbd780346cc.MP3";